import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { SubscriberRequestRecord } from '../../Common/ConsumerModels/SubscriberRequestRecord';

export function useGetAllRequestsBySubscriber(subscriberId: string, shouldReload: boolean) {
  const [subscriberRequestsList, setSubscriberRequestsList] = useState<SubscriberRequestRecord[]>(null);
  const [subscriberRequestsListLoading, setSubscriberRequestsListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */
    if (!shouldReload) {
      setSubscriberRequestsListLoading(true);
      httpClient
        .get<SubscriberRequestRecord[]>(
          `${__API_BASE_URL__}/subscriber/getAllRequestsBySubscriber?subscriberId=${subscriberId}`,
          {
            resource: __CLIENT_ID__,
            headers: {
              'Content-Type': 'application/json',
              'X-Content-Type-Options': 'nosniff',
            },
          }
        )
        .then(({ data }) => {
          const sorted: SubscriberRequestRecord[] = [...data].sort((a, b) =>
          b.submittedDate.localeCompare(a.submittedDate)
        );

        const updatedList: SubscriberRequestRecord[] = sorted.map((item) => {
          const options = Array.isArray(item.egressOptions) ? item.egressOptions : [];
          const has5 = options.includes(5);
          const has6 = options.includes(6);

          if (has5 || has6) {
            const existingEgressOptions = options.filter((key) => key !== 5 && key !== 6);
            const nextEgressOptions = [...existingEgressOptions, has6 ? 6 : 5];

            return {
              ...item,
              egressOptions: nextEgressOptions,
              receivedEgressOptions: options,
              graphEgressOptions: has5 ? 5 : 6,
            };
          }
          return { ...item, receivedEgressOptions: options};
        });

        setSubscriberRequestsList(updatedList);
        setSubscriberRequestsListLoading(false);
        });
    }
  }, [shouldReload]);

  return [subscriberRequestsList, subscriberRequestsListLoading] as const;
}
